import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
// Importing the Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css'
const rootElement = document.getElementById('root')
if (rootElement) {
  // ReactDOM.render(
  //   <React.StrictMode>
  //     <App />
  //   </React.StrictMode>,
  //   rootElement,
  // )
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
}
